import { cn } from "cn";

const LightBoxNavigationButton = ({
  currentSlide,
  slideCount,
  className,
  ...restProps
}: any) => {
  return (
    <button
      {...restProps}
      className={cn(
        /* sorted */
        "absolute top-1/2 z-10 !flex",
        "justify-center items-center",
        "size-8",
        "m-0 -mt-4",
        "backdrop-blur-3xl opacity-80 outline-none ring-0 rounded-full border border-white/24 bg-bg-dark-max/72",
        "hover:text-text-light hover:opacity-100",
        className,
      )}
    />
  );
};

export default LightBoxNavigationButton;
